import { Trans } from "@lingui/macro";
import { ListItem, ListItemButton, Paper, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { WfIconContentAddCircleFill } from "@WahooFitness/redesignr";

function EmptyField({
  fieldPosition,
  openCategoryDialog,
  isLastField,
}: {
  fieldPosition: number;
  openCategoryDialog: () => void;
  isLastField: boolean;
}) {
  return (
    <ListItem
      key="placeholder"
      component={Paper}
      disablePadding
      elevation={4}
      divider={!isLastField}
      sx={{
        cursor: "pointer",
        overflow: "clip",
        "&.MuiListItem-root.MuiPaper-rounded": {
          borderRadius: 0,
        },
        "&.MuiListItem-root.MuiPaper-rounded:first-child": {
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        },
        "&.MuiListItem-root.MuiPaper-rounded:last-of-type": {
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          borderBottom: "none",
        },
      }}
    >
      <ListItemButton sx={{ height: 48, pl: 1 }} onClick={() => openCategoryDialog()}>
        <Box display="flex" flexDirection="row" alignItems="center" width="100%">
          <Box display="flex" alignItems="center" pr={1.5}>
            <Stack alignItems="center" justifyContent="center" sx={{ width: "2.75rem" }}>
              <WfIconContentAddCircleFill
                sx={{ color: "success.main", width: "1.25rem", height: "1.25rem" }}
              />
            </Stack>
            <Typography color="text.disabled" align="right" width="1.5rem" noWrap>
              {fieldPosition}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            justifyContent="flex-start"
            flexGrow={1}
          >
            <Typography>
              <Trans>Add data field</Trans>
            </Typography>
          </Box>
        </Box>
      </ListItemButton>
    </ListItem>
  );
}

export default EmptyField;
